<!-- eslint-disable vue/no-v-html -->

<template>
	<div v-if="svg" v-html="svg"></div>
</template>

<script lang="ts" setup>
	import { ref, onMounted, onUpdated } from 'vue'
	import { getStatusSvg } from '@/composables/status.js'

	const props = defineProps({
		path: {
			type: String,
			required: true
		},
		background: {
			type: String,
			required: false,
			default: undefined
		},
		colour: {
			type: String,
			required: false,
			default: undefined
		},
		autoscale: {
			type: Boolean,
			default: false
		}
	})

	const svg = ref()

	function parseSvg(svgData: string) {
		const parser = new DOMParser()
		return parser.parseFromString(svgData, 'image/svg+xml')
	}

	function changeColour(svgData: string) {
		if (svgData) {
			const xmlDoc = parseSvg(svgData)

			// Background colour
			if (props.background) {
				let shape = xmlDoc.querySelector('.background')

				if (shape) {
					shape.setAttribute('fill', props.background)
				}
			}

			// Icon Colour
			// Note: Currently just looking for white icons
			// so may need a class selector in future for this
			if (props.colour) {
				let shapes = xmlDoc.querySelectorAll('svg *')

				shapes.forEach((shape) => {
					const stroke = shape.getAttribute('stroke')
					const fill = shape.getAttribute('fill')

					// Stroke colour
					if (
						stroke === 'white' ||
						stroke === '#ffffff' ||
						stroke === 'rgb(255, 255, 255)'
					) {
						shape.setAttribute('stroke', props.colour!)
					}

					// Fill colour
					if (fill === 'white' || fill === '#ffffff' || fill === 'rgb(255, 255, 255)') {
						shape.setAttribute('fill', props.colour!)
					}
				})
			}

			const serializer = new XMLSerializer()
			return serializer.serializeToString(xmlDoc)
		}
	}

	function enableAutoscale(svgData: string) {
		if (svgData && props.autoscale) {
			const xmlDoc = parseSvg(svgData)
			let svg = xmlDoc.querySelector('svg')
			svg!.setAttribute('preserveAspectRatio', 'xMidYMid meet')
			svg!.setAttribute('width', '100%')
			svg!.setAttribute('max-width', '1rem')
			svg!.setAttribute('height', '100%')
			const serializer = new XMLSerializer()
			return serializer.serializeToString(xmlDoc)
		}
	}

	async function getIcon() {
		await getStatusSvg(new URL(props.path, window.location.origin).href).then((svgData) => {
			if (svgData && (props.background || props.colour)) {
				svgData = changeColour(svgData)
			}

			if (svgData && props.autoscale) {
				svgData = enableAutoscale(svgData)
			}

			svg.value = svgData
		})
	}

	onMounted(() => {
		if (props.path) {
			getIcon()
		}
	})

	onUpdated(() => {
		getIcon()
	})
</script>
